import { html, LitElement } from "lit";
import { customElement} from "lit/decorators.js";
import styles from './buttons-panel.scss';

/**
 * A layout component grouping and positioning buttons into two distinct areas.
 *
 * @slot back-buttons - Reserved for buttons such as “Previous step”.
 * @slot - The main area for buttons.
 */
@customElement('buttons-panel')
export class ButtonsPanel extends LitElement {
    static override styles = styles;

    // section: properties

    // section: state

    // section: extra fields

    // section: lifecycle

    override render() {
        return html`
            <div>
                <div class="back-buttons">
                    <slot name="back-buttons"></slot>
                </div>
                <div class="buttons">
                    <slot></slot>
                </div>
            </div>
        `;
    }

    // section: extra methods

    // section: event handlers

    // section: private methods
}

declare global {
    interface HTMLElementTagNameMap {
        'buttons-panel': ButtonsPanel;
    }
}
